/* ========================================================================
 * .noConflict()
 * Enclosed everything within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
	
	$.fn.isOnScreen = function(){
	      
	  var win = $(window);
	      
	  var viewport = {
	    top : win.scrollTop(),
	    left : win.scrollLeft()
	  };
	  
	  viewport.right = viewport.left + win.width();
	  viewport.bottom = viewport.top + win.height();
	      
	  var bounds = this.offset();
	      bounds.right = bounds.left + this.outerWidth();
	      bounds.bottom = bounds.top + this.outerHeight();
	      
	  return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

	};

	/// load foundation
	$(document).foundation();
	
	/// Scroll animations
    var scrollTimeout;
    var throttle = 50;

    function scroll_function(scroll) {
        if(scroll > 1) {
            $('.navbar').addClass('scroll');
        } else {
            $('.navbar').removeClass('scroll');
        }

        if (!scrollTimeout) {
            scrollTimeout = setTimeout(function () {
                var st = $(this).scrollTop();
                
                checkDivs();

                scrollTimeout = null;
            }, throttle);
        }

        lazy();
    } scroll_function($(window).scrollTop());

	$(window).on('scroll', function () {
		var scroll = $(this).scrollTop();
        scroll_function(scroll);
	});

	function lazy() {
		$('img.lazy').each(function(){
			if($(this).isOnScreen()){
				$(this).attr('src', $(this).attr('data-src'));
				$(this).removeClass('lazy');

				if($(this).parent().hasClass('liquid')) {
					$(this).parent().css('background-image', 'url(' + $(this).attr('data-src') + ')');
				}
			}
		});
	} lazy();

    /// loader fade out
    setTimeout(function(){
        $('.load-overlay').velocity('fadeOut', { delay: 10, duration: 400 });
    }, 200);

	$('.bel-afspraak-open').click(function(){
        $('body').addClass('bel-afspraak_active');
        $('.bel-afspraak').velocity('fadeIn');
	});

	$('.bel-close').click(function(){
        $('body').removeClass('bel-afspraak_active');
	   $('.bel-afspraak').velocity('fadeOut');
    });

	$('.liquid').imgLiquid();
	
	/// Sliders
	$('.logo-slider').slick({
	  dots: false,
	  arrows: true,
	  infinite: true,
	  speed: 300,
	  autoplay: true,
	  autoplaySpeed: 2000,
	  slidesToShow: 5,
	  slidesToScroll: 1,
	  nextArrow: '<div class="right"><i class="fa fa-arrow-circle-right"></i></div>',
  	  prevArrow: '<div class="left"><i class="fa fa-arrow-circle-left"></i></div>',
	});

	$('.brands-holder').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        autoplay: true,
        autoplaySpeed: 4000,
        slidesToShow: 8,
        slidesToScroll: 8,
        responsive: [
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 5
            }
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4
            }
          },
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
    });

    $('.cases-slider').slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 300,
        autoplay: true,
        autoplaySpeed: 4000,
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: [
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
        ]
    });

    $('.foto-slider').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        autoplay: true,
        autoplaySpeed: 4000,
        centerMode: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 825,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 620,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
    });

    $('.team-single-top').slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        autoplay: false,
        asNavFor: '.team-slider-bottom',
        slidesToShow: 1,
        centerMode: true,
        slidesToScroll: 1,
    });

    $('.team-slider-bottom').slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        autoplay: false,
        slidesToShow: 6,
        focusOnSelect: true,
		    centerMode: true,
        asNavFor: '.team-single-top',
        slidesToScroll: 6,
    });

    $('.slider-items').slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        prevArrow: '<span class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></span>',
        nextArrow: '<span class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></span>',
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
    });

    $('.hero_slider').slick({
        dots: true,
        arrows: false,
        infinite: false,
        speed: 1000,
        autoplaySpeed: 3000,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        cssEase: 'linear'
    });

    $(".imgLiquidFill").imgLiquid();

	$('.double-col').matchHeight();
	$('.team-columns').matchHeight();
	$('.timeline-content').matchHeight();
	$('.blog-col').matchHeight();
	$('.mh-col').matchHeight();
	$('.col-mh').matchHeight();
	$('.large-col ').matchHeight();
  $('.hero_slider .bg').matchHeight();

	if($(window).width() < 767){
        $('.team-col').click(function(){
            $(this).find('.inner').fadeToggle();
            $(this).find('.overlay').fadeToggle();
        });
    }else{
        $('.team-col').hover(function(){
            $(this).find('.inner').fadeToggle();
            $(this).find('.overlay').fadeToggle();
        });
    }

    var checkDivs = function(){
        $('.anim.start').each(function(){
            if($(this).isOnScreen() === true) {
              var anim = $(this).attr('data-anim');
              var speed = $(this).attr('data-speed');
              var delay = $(this).attr('data-delay');
              
              if(speed === null){
                speed = 500;
              }

              if(anim === 'fadeUp'){
                $(this).velocity({translateZ: 0, translateY: '-30px', opacity: 0}, {duration: 0, delay: 0});
                $(this).removeClass('start').addClass('finish');
                $(this).velocity({translateZ: 0, translateY: '0px', opacity: 1}, {duration: speed, delay: delay});
              }

              if(anim === 'fadeDown'){
                $(this).velocity({translateZ: 0, translateY: '30px', opacity: 0}, {duration: 0, delay: 0});
                $(this).removeClass('start').addClass('finish');
                $(this).velocity({translateZ: 0, translateY: '0px', opacity: 1}, {duration: speed, delay: delay});
              }

              if(anim === 'fadeLeft'){
                $(this).velocity({translateZ: 0, translateX: '-30px', opacity: 0}, {duration: 0, delay: 0});
                $(this).removeClass('start').addClass('finish');
                $(this).velocity({translateZ: 0, translateX: '0px', opacity: 1}, {duration: speed, delay: delay});
              }

              if(anim === 'fadeRight'){
                $(this).velocity({translateZ: 0, translateX: '30px', opacity: 0}, {duration: 0, delay: 0});
                $(this).removeClass('start').addClass('finish');
                $(this).velocity({translateZ: 0, translateX: '0px', opacity: 1}, {duration: speed, delay: delay});
              }

            }
        });      
    };

    $('.anim').each(function(){
        $(this).addClass('start').css('opacity', 0);
    });

    $('.bedrijven-pagina.overview-pagina .bedrijf-col').click(function(){
      $(this).toggleClass('active');
    });

    var show_award = localStorage.getItem("show_award");

    if(!show_award) {
      setTimeout(function(){
        $('.award').addClass('open');
      }, 1000);
    }

    $('.award .close').click(function(){
      $('.award').removeClass('open');
      localStorage.setItem("show_award", "false");
    });

})(jQuery); // Fully reference jQuery after this point.